'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorTool = require('./colorTools/ColorTool');

var _ColorTool2 = _interopRequireDefault(_ColorTool);

var _IconTool = require('./iconTools/IconTool');

var _IconTool2 = _interopRequireDefault(_IconTool);

var _CaptionTool = require('./captionTool/CaptionTool');

var _CaptionTool2 = _interopRequireDefault(_CaptionTool);

var _AttachmentTool = require('./attachmentTool/AttachmentTool');

var _AttachmentTool2 = _interopRequireDefault(_AttachmentTool);

var _RichTextToolList = require('./richContentTools/RichTextToolList');

var _RichTextToolList2 = _interopRequireDefault(_RichTextToolList);

var _LockTool = require('./lockTool/LockTool');

var _LockTool2 = _interopRequireDefault(_LockTool);

var _ShowBackgroundTool = require('./showBackgroundTool/ShowBackgroundTool');

var _ShowBackgroundTool2 = _interopRequireDefault(_ShowBackgroundTool);

var _StartArrowTool = require('./arrowTools/StartArrowTool');

var _StartArrowTool2 = _interopRequireDefault(_StartArrowTool);

var _EndArrowTool = require('./arrowTools/EndArrowTool');

var _EndArrowTool2 = _interopRequireDefault(_EndArrowTool);

var _toolbarConstants = require('../toolbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var SelectionTool = function SelectionTool(_ref) {
    var toolMode = _ref.toolMode,
        selectedElements = _ref.selectedElements,
        editorKey = _ref.editorKey,
        gridSize = _ref.gridSize;

    switch (toolMode.id) {
        case _toolbarConstants.TOOLS.RICH_TEXT.id:
            return _react2.default.createElement(_RichTextToolList2.default, { selectedElements: selectedElements, editorKey: editorKey });
        case _toolbarConstants.TOOLS.COLOR.id:
            return _react2.default.createElement(_ColorTool2.default, { selectedElements: selectedElements, name: toolMode.name });
        case _toolbarConstants.TOOLS.ICON.id:
            return _react2.default.createElement(_IconTool2.default, { selectedElements: selectedElements, name: toolMode.name, gridSize: gridSize });
        case _toolbarConstants.TOOLS.CAPTION.id:
            return _react2.default.createElement(_CaptionTool2.default, { selectedElements: selectedElements, name: toolMode.name });
        case _toolbarConstants.TOOLS.ATTACHMENT.id:
            return _react2.default.createElement(_AttachmentTool2.default, { selectedElements: selectedElements, name: toolMode.name });
        case _toolbarConstants.TOOLS.LOCK.id:
            return _react2.default.createElement(_LockTool2.default, { selectedElements: selectedElements, name: toolMode.name });
        case _toolbarConstants.TOOLS.SHOW_BACKGROUND.id:
            return _react2.default.createElement(_ShowBackgroundTool2.default, { selectedElements: selectedElements, name: toolMode.name });
        case _toolbarConstants.TOOLS.START_ARROW.id:
            return _react2.default.createElement(_StartArrowTool2.default, { selectedElements: selectedElements, name: toolMode.name });
        case _toolbarConstants.TOOLS.END_ARROW.id:
            return _react2.default.createElement(_EndArrowTool2.default, { selectedElements: selectedElements, name: toolMode.name });
        default:
            return null;
    }
};

SelectionTool.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    toolMode: _propTypes2.default.object,
    selectedElements: _propTypes2.default.object,
    editorKey: _propTypes2.default.string
};

exports.default = SelectionTool;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/SelectionTool.js
// module id = 2223
// module chunks = 0